import { gql, TypedDocumentNode } from '@common/hooks';
import {
  BillingCardsByOrganizationUnitsAndRolesQueryCgResponse,
  BillingCardsByOrganizationUnitsAndRolesQueryVariables,
} from '@common/graphql/schema/codegen-graphql';
import { BillingCardFragment } from '@institutions/graphql';

export type BillingCardCollectionType =
  BillingCardsByOrganizationUnitsAndRolesQueryCgResponse['billingCardsByOrganizationUnitsAndRoles']['collection'][number];

export const BILLING_CARDS_BY_ORGANIZATION_UNITS_AND_ROLES_QUERY: TypedDocumentNode<
  BillingCardsByOrganizationUnitsAndRolesQueryCgResponse,
  BillingCardsByOrganizationUnitsAndRolesQueryVariables
> = gql`
  query BillingCardsByOrganizationUnitsAndRoles(
    $input: BillingCardsByOrganizationUnitsAndRolesInput!
  ) {
    billingCardsByOrganizationUnitsAndRoles(input: $input) {
      collection {
        uniqueKey
        role {
          id
          abbreviation
          name
        }
        roleLevel
        organizationUnit {
          id
          name
          costCenter
          department {
            id
            organizationBusiness {
              id
              name
            }
          }
          clinicalUnit {
            id
            displayName
          }
        }
        billingCard {
          id
          name
          serial
          createdAt
          ...BillingCardFragment
        }
      }
      metadata {
        totalCount
      }
    }
  }
  ${BillingCardFragment}
`;
